import { render, staticRenderFns } from "./cdy.vue?vue&type=template&id=fb77a4de&scoped=true&"
var script = {}
import style0 from "./cdy.vue?vue&type=style&index=0&id=fb77a4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb77a4de",
  null
  
)

export default component.exports